<template>
  <v-row>

    <template v-if="!loading">
      <v-col cols="12" class="pa-3">
        <showConvocationForm v-if="convocation_form.version=='v1'" :data="convocation_form" />
        <showConvocationFormV2 v-if="convocation_form.version=='v2'" :data="convocation_form" />
        <showConvocationFormV3 v-if="convocation_form.version=='v3'" :data="convocation_form" />
      </v-col>
      
      <v-col cols="12" class="d-sm-flex pt-8">
        <v-btn
          depressed
          :block="$vuetify.breakpoint.xsOnly"
          class="mr-auto mt-2"
          color="primary"
          :to="{ name: 'showEntrepreneurshipsEdition', params: { edition_id: this.edition_id }}"
          >
          <v-icon left>
            mdi-arrow-left
          </v-icon>
          Volver
        </v-btn>

        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          class="mr-2 mt-2"
          depressed
          color="primary"
          :loading="loading_download"
          @click="downloadPDF" >
          <v-icon
            dark
          >
            mdi-download
          </v-icon>
          Descargar PDF
        </v-btn>
      </v-col>

    </template>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import download from 'downloadjs'
  const VUE_URL_API = process.env.VUE_APP_URL_API

  import showConvocationForm from '@/components/entrepreneur/convocation/showConvocationForm.vue'
  import showConvocationFormV2 from '@/components/convocation_form/showConvocationFormV2.vue'
  import showConvocationFormV3 from '@/components/convocation_form/showConvocationFormV3.vue'

  export default {
    name: 'showConvocationFormAccepted',
    components: {
      showConvocationForm,
      showConvocationFormV2,
      showConvocationFormV3
    },
    data: () => ({
      loading:true,
      loading_download: false,
      edition_id:null,
      entrepreneurship_id:null,

      entrepreneurship:[],
      convocation_form: [],
    }),

    methods:{
      async getConvocationForm(){
        await axios.get('admin/edition/'+this.edition_id+'/entrepreneurships/'+this.entrepreneurship_id+'/convocation-form').then(response =>{
          this.convocation_form = response.data.data.convocation_form
          this.loading=false
        }).catch(error => {
          console.log(error)
        })
      },

      async downloadPDF(){
        this.loading_download=true
        this.url = VUE_URL_API + '/admin/edition/'+this.edition_id+'/convocation-form/'+this.convocation_form.id+'/generate-pdf'
        await axios.get(
          this.url, 
          {responseType: 'blob'}
        ).then((response) => {
          //window.open(URL.createObjectURL(response.data));
          const content = response.headers['content-type'];
          download(response.data, this.convocation_form.id+' - '+ this.convocation_form.title , content)
          this.loading_download=false
        })
      },
    },

    created(){
      this.edition_id = this.$route.params.edition_id;
      this.entrepreneurship_id = this.$route.params.entrepreneurship_id;
      this.getConvocationForm()
      },
  }
</script>